import React from 'react';
import "./icon.css";
import Global from '../../global';


const Icon = (props) => {

  
    const iconProvider = (iconName) =>
    {
        if(iconName==="Home")
        {
           return "fa fa-home"
        }
        else if(iconName==="Music")
        {
           return "ri-music-fill";
        }
        else if(iconName==="Star")
        {
            return "ri-star-line";
        }
        else if(iconName==="Document")
        {
            return "ri-file-fill";
        }
        else if(iconName==="Padlock")
        {
            return "ri-lock-fill";
        }
        else if(iconName==="Dollar")
        {
            return "fa fa-usd";
        }
        else if(iconName==="Crown")
        {
            return "ri-vip-crown-2-fill";
        }
        else if(iconName==="Audio")
        {
            return "fa fa-headphones";
        }
        else if(iconName==="Profile")
        {
            return "fa fa-user";
        }
        else if(iconName==="Bar Menu")
        {
            return "ri-menu-line";
        }
        else if(iconName==="Dot Menu")
        {
            return "fa fa-ellipsis-v"
        }
       
        else if(iconName==="Bell")
        {
            return "ri-notification-fill";
        }
        else if(iconName==="Video")
        {
            return "ri-video-fill";
        }
        else if(iconName==="Sort")
        {
            return "fa fa-sort"
        }
        else if(iconName==="Photo")
        {
            return "ri-image-fill";
        }
        else if(iconName==="Eye")
        {
            return "ri-eye-fill";
        }
        else if(iconName==="Search")
        {
            return "ri-search-line";
        }
        else if(iconName==="Movie")
        {
            return "ri-movie-fill";
        }
        else if(iconName==="Setting")
        {
            return "ri-settings-2-line";
        }
        else if(iconName==="Globe")
        {
            return "ri-globe-fill";
        }
        else if(iconName==="Folder")
        {
            return "ri-folder-line";
        }
        else if(iconName==="Paint")
        {
            return "ri-paint-fill";
        }
        else if(iconName==="Cast")
        {
            return "ri-cast-fill";
        }
        else if(iconName==="Refresh")
        {
            return "ri-refresh-line";
        }
        else if(iconName==="Play")
        {
            return "ri-play-fill"
        }
        else if(iconName==="Pause")
        {
            return "ri-pause-fill"
        }
        else if(iconName==="Stop")
        {
            return "ri-stop-fill"
        }
        else if(iconName==="Trash")
        {
            return "ri-delete-bin-fill"
        }
        else if(iconName==="Close")
        {
            return "ri-close-fill"
        }
        else
        {
            return "ri-lock-fill";
        }

    }


   if(Global.ICON)
   {
    return (
        <span className={props.flag==="transparent"?"premiumicon backicon": props.flag==="inline"?"inlineIcon":"premiumicon"}><i className={iconProvider(Global.ICONNAME)}></i></span>
     );
   }
   else
   {
    return (
        <span className='premiumHide'></span>
     );
   }
};

export default Icon;